import { render, staticRenderFns } from "./EstimatedNumberOfFramesFormPart.PD-10940.vue?vue&type=template&id=0ef4451b"
import script from "./EstimatedNumberOfFramesFormPart.PD-10940.vue?vue&type=script&lang=js"
export * from "./EstimatedNumberOfFramesFormPart.PD-10940.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports